// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__2s2dg","container":"styles_container__xv_6N"};